// extracted by mini-css-extract-plugin
export var offlineNotificaton = "fp_LV";
export var offlineNotificaton__button = "fp_LY";
export var offlineNotificaton__header = "fp_LX";
export var offlineNotificaton__text = "fp_LZ";
export var offlineNotificaton__withCookie = "fp_LW";